import React from 'react';

const CsatFeedbackDrawer = React.lazy(() =>
  import('./csat-feedback').then((module) => ({
    default: module.CsatFeedbackDrawer,
  })),
);

const CsatFeedbackDrawerLazy = () => (
  <React.Suspense fallback={null}>
    <CsatFeedbackDrawer />
  </React.Suspense>
);

export default CsatFeedbackDrawerLazy;
